import { render, staticRenderFns } from "./Attributes.vue?vue&type=template&id=b251542a&scoped=true&"
import script from "./Attributes.vue?vue&type=script&lang=js&"
export * from "./Attributes.vue?vue&type=script&lang=js&"
import style0 from "./Attributes.vue?vue&type=style&index=0&id=b251542a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b251542a",
  null
  
)

export default component.exports